import React, { useEffect, useState } from 'react';
import { Col, Divider, Modal, SelectPicker, Grid, Row, Table, Stack } from 'rsuite';
import globalIP from '@/GlobelIP';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Icon } from '@rsuite/icons';
import ArrowLeftIcon from '@rsuite/icons/ArrowLeft';
import ArrowRightIcon from '@rsuite/icons/ArrowRight';
const { Column, HeaderCell, Cell } = Table;
import ReactImageMagnify from 'react-image-magnify';
const ProductQuickView = ({
  data11,
  label,
  handleClose,
  open,
  size,
  modeldata,
  handlePrevImage,
  handleNextImage,
  selectedImagePath,
  setSelectedImagePath,
  sizeshow,
  unitOptions,
  selectedUnit,
  handleSizeChange,
  convertDimensions,
  finShow,
  attributesName,
  costid
}) => {
  const [calcwidth, setcalcwidth] = useState(800);
  const [cost, setCost] = useState({
    totalinr: 0,
    targetcostUSD: 0
  });
  useEffect(() => {
    if (selectedImagePath?.url) {
      // Create a new Image object
      const img = new Image();
      img.src = globalIP + selectedImagePath?.url;

      // Once the image is loaded, calculate the width
      img.onload = () => {
        const newCalcWidth = (800 * img.width) / img.height;
        setcalcwidth(newCalcWidth);
        // console.log('calcwidth', newCalcWidth);
      };
    }
    // console.log('selectedImagePath', selectedImagePath);
  }, [selectedImagePath?.url]);
  useEffect(() => {
    if (costid) {
      fetchData();
    }
  }, [costid]);
  const fetchData = async () => {
    const response = await fetch(
      `${globalIP}/api/costings?populate=*&filters[ProductId][$eq]=${costid}`
    );
    const json = await response.json();
    setCost({
      totalinr: json.data[0].attributes.totalinr,
      targetcostUSD: json.data[0].attributes.targetcostUSD
  })
  };
  return (
    <>
      <Modal
        size={window.innerWidth >= 746 ? 'full' : 'calc(100% - -7px)'}
        open={open}
        onClose={handleClose}
      >
        <Modal.Header>
          <Modal.Title>
            <h5>Product Details</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '0px' }}>
          {modeldata?.map((item, index) => {
            return (
              <SwiperSlide key={item.id}>
                <Grid fluid>
                  <Row>
                    <Col lg={12} xs={24} style={{ textAlign: '-webkit-center' }}>
                      <div
                        style={{}}
                        className="arrow arrow-left"
                        onClick={() => handlePrevImage(item)}
                      >
                        <Icon as={ArrowLeftIcon} />
                      </div>
                      <div className="imgp1" style={{ height: '400px', display: 'flex' }}>
                        <ReactImageMagnify
                          {...{
                            className: 'magnify',
                            imageStyle: { objectFit: 'contain' },
                            smallImage: {
                              alt: 'Wristwatch by Ted Baker London',
                              height: 400,
                              width: 400,
                              className: 'magnify',
                              // isFluidWidth: true,

                              src:
                                selectedImagePath.url && selectedImagePath.id == item.id
                                  ? `${globalIP}${selectedImagePath.url}`
                                  : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`
                            },
                            largeImage: {
                              src:
                                selectedImagePath.url && selectedImagePath.id == item.id
                                  ? `${globalIP}${selectedImagePath.url}`
                                  : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`,
                              width: calcwidth,
                              height: 800
                            },
                            isHintEnabled: true,
                            enlargedImagePosition: 'beside',
                            enlargedImageContainerDimensions: { width: 700, height: 500 }
                          }}
                        />
                      </div>
                      <div
                        style={{}}
                        className="arrow1 arrow-right"
                        onClick={() => handleNextImage(item)}
                      >
                        <Icon as={ArrowRightIcon} />
                      </div>
                      {!item.attributes.MultipleImage.data && (
                        <div style={{ padding: '15px 50px' }}>
                          <Swiper
                            spaceBetween={20}
                            navigation={true}
                            slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                            pagination={{ clickable: true }}
                            modules={[Navigation]}
                            className="nestedSwiper"
                          >
                            <SwiperSlide>
                              <div
                                style={{
                                  height: '80px',
                                  borderRadius: ' 5px',
                                  overflow: 'hidden',
                                  objectFit: 'contain'
                                }}
                              >
                                <img
                                  src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                  alt=""
                                  style={{
                                    width: '100%',
                                    objectFit: 'contain',
                                    height: '100%'
                                  }}
                                  onClick={() =>
                                    setSelectedImagePath({
                                      url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                      id: item.id,
                                      default: true
                                    })
                                  }
                                />
                              </div>
                            </SwiperSlide>
                          </Swiper>
                        </div>
                      )}
                      {item.attributes.MultipleImage.data && (
                        <div style={{ padding: '15px 10px' }}>
                          <Swiper
                            spaceBetween={20}
                            navigation={true}
                            slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                            pagination={{ clickable: true }}
                            modules={[Navigation]}
                            className="nestedSwiper"
                          >
                            <SwiperSlide>
                              <div
                                style={{
                                  height: '80px',
                                  borderRadius: '5px',
                                  objectFit: 'contain',
                                  overflow: 'hidden'
                                }}
                                className={
                                  selectedImagePath.url ===
                                    item?.attributes?.CoverImage?.data?.attributes?.url &&
                                  selectedImagePath.id === item.id
                                    ? 'image-product-select image-product-select-active'
                                    : null
                                }
                              >
                                <img
                                  src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                  alt=""
                                  style={{
                                    width: '100%',
                                    objectFit: 'contain',
                                    height: '100%'
                                  }}
                                  onClick={() =>
                                    setSelectedImagePath({
                                      url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                      id: item.id,
                                      default: true
                                    })
                                  }
                                />
                              </div>
                            </SwiperSlide>

                            {[...item.attributes.MultipleImage.data]
                              .filter(img => img?.attributes?.url?.trim()) // remove blank
                              .filter(
                                (img, index, self) =>
                                  index ===
                                  self.findIndex(i => i.attributes.url === img.attributes.url)
                              ) // remove duplicate
                              .sort((a, b) =>
                                a.attributes.name
                                  .toLowerCase()
                                  .localeCompare(b.attributes.name.toLowerCase())
                              )
                              .map(multiImage => (
                                <SwiperSlide key={multiImage.id}>
                                  <div
                                    style={{
                                      height: '80px',
                                      borderRadius: '5px',
                                      objectFit: 'contain',
                                      overflow: 'hidden'
                                    }}
                                    className={
                                      selectedImagePath.url === multiImage.attributes.url &&
                                      selectedImagePath.id === item.id
                                        ? 'image-product-select image-product-select-active'
                                        : null
                                    }
                                  >
                                    <img
                                      src={`${globalIP}${multiImage.attributes.url}`}
                                      alt=""
                                      style={{
                                        width: '100%',
                                        objectFit: 'contain',
                                        height: '100%'
                                      }}
                                      onClick={() =>
                                        setSelectedImagePath({
                                          url: multiImage.attributes.url,
                                          id: item.id,
                                          default: true
                                        })
                                      }
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                          </Swiper>
                        </div>
                      )}
                    </Col>
                    <Col lg={12} xs={24}>
                      <div
                        style={{ padding: '10px 20px', marginTop: '-14px' }}
                        className="slide-product-table"
                      >
                        <Stack justifyContent="space-between">
                          <div className="slide-product-name roboto-medium">
                            {item.attributes.ProductName}
                          </div>
                          <Stack direction='column' alignItems='flex-start'>
                          <div>Cost(INR): {cost.totalinr}</div>
                          <div>Cost({item.attributes.SellingPriceCurrency}): {cost.targetcostUSD}</div>
                          <div>SalePrice(INR): {item.attributes.ProductCost}</div>
                          <div>Cost({item.attributes.SellingPriceCurrency}): {item.attributes.SellingPrice}</div>
                          </Stack>
                        </Stack>
                        <div className="slide-product-details ">
                          <span className="roboto-medium">Description</span>
                          <p className="roboto-regular">{item.attributes.Description}</p>
                        </div>
                        <Divider className="divide dvd" />

                        {!sizeshow && (
                          <div >
                            <div style={{ display: 'flex', alignItems: 'center' }}></div>

                            {item.attributes.SetStatus !== 'Set' && (
                              <div>
                                <span
                                  className="roboto-medium"
                                  style={{ display: 'flex', alignItems: 'center' }}
                                >
                                  <p style={{ marginLeft: '0rem', color: '#005c80' }}>LxWxH</p>
                                  <SelectPicker
                                    data={unitOptions}
                                    searchable={false}
                                    defaultValue={selectedUnit}
                                    onChange={handleSizeChange}
                                    size="sm"
                                    cleanable={false}
                                  />
                                </span>
                                <p>
                                  {data11[0].Length.toFixed(2)} x {data11[0].Width.toFixed(2)} x{' '}
                                  {data11[0].Height.toFixed(2)} {selectedUnit}
                                </p>
                              </div>
                            )}
                            <p className="roboto-regular">
                              {(() => {
                                const isSet = item.attributes.SetStatus === 'Set';

                                if (isSet) {
                                  const { dimensions, unit } = convertDimensions(
                                    item.attributes.SetSizes.map(({ Length, Width, Height }) => ({
                                      Length,
                                      Width,
                                      Height
                                    })),
                                    item.attributes.SizeUnit
                                    // sizeUnit
                                  );

                                  return (
                                    <Table
                                      height={180}
                                      width={550}
                                      data={data11}
                                      onRowClick={rowData => {
                                        // console.log(rowData);
                                      }}
                                      bordered
                                      cellBordered
                                      wordWrap="break-word"
                                      rowHeight={20}
                                    >
                                      <Column width={120} fixed align="center">
                                        <HeaderCell align="center"><b>Part Desc.</b></HeaderCell>
                                        <Cell dataKey="Description" />
                                      </Column>

                                      <Column width={250} align="center">
                                        <HeaderCell style={{ marginTop: '-4px' }} align="center">
                                          <b>LxWxH</b>
                                          <SelectPicker
                                            data={unitOptions}
                                            searchable={false}
                                            value={selectedUnit}
                                            onChange={handleSizeChange}
                                            size="xs"
                                            cleanable={false}
                                            style={{ marginLeft: '8px' }}
                                          />
                                        </HeaderCell>
                                        <Cell>
                                          {rowData =>
                                            `${rowData.Length.toFixed(2) || 0}x${
                                              rowData.Width.toFixed(2) || 0
                                            }x${rowData.Height.toFixed(2) || 0} ${rowData.SizeUnit}`
                                          }
                                        </Cell>
                                      </Column>

                                      <Column width={100} align="center">
                                        <HeaderCell><b>{label[0]?.attributes.NetWgt}</b></HeaderCell>
                                        <Cell dataKey="NetWt" />
                                      </Column>

                                      <Column width={100} align="center" align="center">
                                        <HeaderCell><b>{label[0]?.attributes.color}</b></HeaderCell>
                                        <Cell dataKey="ColorName" />
                                      </Column>
                                      {finShow && (
                                        <>
                                          <Column width={120} align="center">
                                            <HeaderCell><b>Finish</b></HeaderCell>
                                            <Cell dataKey="FinishName" />
                                          </Column>

                                          <Column width={150} align="center">
                                            <HeaderCell><b>Mat. Name</b></HeaderCell>
                                            <Cell dataKey="MatName" />
                                          </Column>
                                        </>
                                      )}
                                    </Table>
                                  );
                                }
                              })()}
                            </p>
                          </div>
                        )}
                          <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            Set Status
                          </div>
                          <div>{item.attributes.SetStatus}</div>
                        </div>
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.AliasCode || 'Alias Code'}
                          </div>
                          <div>{item.attributes.ProductId}</div>
                        </div>
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.Category || 'Category'}
                          </div>
                          <div>{item.attributes.CategoryName}</div>
                        </div>
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.ProductType || 'Product Type'}
                          </div>
                          <div>{item.attributes.ProductTypeName}</div>
                        </div>
                        {item.attributes.SetStatus !== 'Set' && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.finish || 'Finish'}
                            </div>
                            <div>{item.attributes.FinishName}</div>
                          </div>
                        )}
                        {item.attributes.SetStatus !== 'Set' && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">{attributesName?.color || 'Color'}</div>
                            <div>{item.attributes.ColorName}</div>
                          </div>
                        )}
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">{attributesName?.cbm || 'CBM'}</div>
                          <div>{item.attributes.Total_CBM}</div>
                        </div>
                        {sizeshow && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.SizeRange || 'Free Size'}
                            </div>
                            <div>{item.attributes.SizeRange}</div>
                          </div>
                        )}
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.GrossWgt || 'Gross Weight'}
                          </div>
                          <div>{item.attributes.GrossWeight}</div>
                        </div>
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.NetWgt || 'Net Weight'}
                          </div>
                          <div>{item.attributes.NetWeight}</div>
                        </div>
                            {/* <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.MOQ || 'MOQ'}
                          </div>
                          <div>{item.attributes.MOQ}</div>
                        </div> */}
                      </div>
                    </Col>
                  </Row>
                </Grid>
              </SwiperSlide>
            );
          })}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProductQuickView;
